<template>
  <div class="ai-list">
    <!--智能搜索loading-->
    <AIloading v-if="aiLoading"/>
    <!--智能搜索超时提醒-->
    <OverTimeTip v-else-if="isShowOverTimeTip"/>
    <div class="ai-block" v-else>
      <div class="ai-block-cons" v-if="showAiBlockCons">
        <!--智能回答-->
        <IntelligentRes
          :AIresult="AIresult"
          :summary-loading="summaryLoading"
          :message-content="messageContent"
          :is-over-time="isOverTime"
          :user-info="userInfo"
          :cur-tab-type="curTabType"
          @handleRefersh="handleRefersh"
        />
        <template v-if="curShowList.length > 0">
          <img src="../../../assets/images/home/img11.png" class="tip-img2" alt="">
          <div class="cons-list">
            <div class="items-blocks" v-for="(item, index) in curShowList" :key="index"
                 v-longpress="() => handleLongPress(item, index)"
                 :class="item.isShowFeedback ? 'show-feedback' : ''">
              <ListItem :item="item" :user-info="userInfo" :cur-tab-key="curTabKey">
                <template #Feedback>
                  <div class="wrapp-con" v-if="item && item.isShowFeedback">
                    <div class="wrapp-bg"></div>
                    <div class="wrapps">
                      <img src="../../../assets/images/common/icon-close-btn.png" @click.stop="handleClose"
                           class="img-close" alt="">
                      <div class="top-txt">
                        该内容对您当前技能提升是否有帮助?
                      </div>
                      <div class="top-btn">
                        <div class="btn-left" @click.stop="handleFeedBack(true)">
                          <img src="../../../assets/images/home/icon_like@2x.png" class="img-icon" alt="">
                          <div class="btn-txt">是</div>
                        </div>
                        <div class="btn-left" @click.stop="handleFeedBack(false)">
                          <img src="../../../assets/images/home/icon_like@2x2.png" class="img-icon" alt="">
                          <div class="btn-txt">否</div>
                        </div>
                        <div class="btn-txt2" @click.stop="isFeedBack = true">反馈</div>
                      </div>
                    </div>
                  </div>
                </template>
              </ListItem>
            </div>
            <div class="view-more-box" @click.stop="showMoreList" v-if="!isAllDataShown">
              <span>查看更多</span>
              <img src="@/assets/images/home/img14.png" alt="">
            </div>
          </div>
        </template>
      </div>
      <div class="ai-question ai-block-cons" v-if="showAiBlockCons && userInfo.memberType === 1">
        <template v-if="AIresult.questions && AIresult.questions.length > 0">
          <img src="../../../assets/images/home/img10.png" class="tip-img3"/>
          <div class="tag" v-for="(item, index) in AIresult.questions" :key="index" @click="$emit('search', item)">
            {{ item }}
          </div>
        </template>
        <template v-else-if="questionsLoading">
          <img src="../../../assets/images/home/img10.png" class="tip-img3"/>
          <div class="ai-cons-html">正在为您生成，请稍候...</div>
        </template>
        <template v-else-if="isOverTime">
          <div class="top">
            <img src="../../../assets/images/home/img10.png" class="tip-img3"/>
            <img src="@/assets/images/refresh.png" alt="" v-if="userInfo.memberType === 1" class="refresh"
                 @click.stop="handleRefersh(4)">
          </div>
          <div class="ai-cons-html">超时,请重试...</div>
        </template>
        <template v-else>
          <div class="top">
            <img src="../../../assets/images/home/img10.png" class="tip-img3"/>
            <img src="@/assets/images/refresh.png" alt="" v-if="userInfo.memberType === 1" class="refresh"
                 @click.stop="handleRefersh(4)">
          </div>
          <div class="ai-cons-html">依据您提出的问题，站点暂时缺少该部分内容，请期待后续更新。</div>
        </template>
      </div>
    </div>
    <van-overlay :show="isFeedBack" @click="isFeedBack = false">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">反馈</div>
        <div class="wrap-con">
          <van-field v-model="feedModel" rows="2" autosize type="textarea" maxlength="200"
                     placeholder="请输入您的反馈，以便我们更好的为您推荐学习内容" show-word-limit/>
        </div>
        <div class="warp-btn">
          <div class="btn btn1" @click="isFeedBack = false">取消</div>
          <div class="btn btn2" @click="handleFeedBack('feedback')">提交反馈</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import AIloading from './AIloading.vue'
import OverTimeTip from './OverTimeTip.vue'
import IntelligentRes from './IntelligentRes.vue'
import {getListBylakehouseId, sendFeedback, updateSearchDuration} from '../../../api/api'
import ListItem from './ListItem.vue'
import {handleTraceSearchLog} from '../../../utils/trace'
import apiClient from './aiRequest' // 引入封装的请求工具
import {fetchEventSource} from '@microsoft/fetch-event-source'

export default {
  props: ['userInfo', 'curTabKey', 'searchValue', 'assistantIsStop', 'curTabType'],
  data() {
    return {
      AIresult: {
        questions: [],
        llm_result: '',
        caseResult: [],
        articleResult: [],
        courseResult: [],
      },
      messageContent: '',
      isFeedBack: false,
      feedModel: '',
      feedBackIndex: 0,
      timeCount: 1,
      isOverTime: false, // 超时提醒
      AIParams: {},
      aiLoading: false, // AI搜索的 加载状态
      displayQueue: [],
      listStartTime: null,
      summaryStartTime: null,
      questionsStartTime: null,
      settime: null, // 定时器
      controller1: null,
      controller2: null,
      controller3: null,
      controller4: null,
      overTimeCount: 20,
      questionsLoading: false,
      summaryLoading: false,
      showMoreCount: { // 记录查看更多按钮点击的次数, 为了缓存
        course: 0,
        article: 0,
        case: 0
      },
    }
  },
  watch: {
    searchValue: {
      handler(val) {
        if (!val) {
          this.resetData()
        }
      }
    }
  },
  computed: {
    isShowOverTimeTip() {
      if (!this.userInfo) return false
      if (this.userInfo.memberType === 0) return this.isOverTime
      if (this.userInfo.memberType === 1) {
        if (this.hasCommonResults || this.hasLlmResult || this.hasQuestions) return false
        return this.isOverTime
      }
    },
    hasCommonResults() {
      const AIresult = this.AIresult || {}
      return (AIresult.courseResult && AIresult.courseResult.length > 0) ||
        (AIresult.articleResult && AIresult.articleResult.length > 0) ||
        (AIresult.caseResult && AIresult.caseResult.length > 0)
    },
    hasLlmResult() {
      const AIresult = this.AIresult || {}
      return AIresult.llm_result
    },
    hasQuestions() {
      const AIresult = this.AIresult || {}
      return AIresult.questions && AIresult.questions.length > 0
    },
    showAiBlockCons() {
      const userInfo = this.userInfo || {}
      const isLoading = this.aiLoading
      if (userInfo.memberType === 0) {
        return !isLoading && this.hasCommonResults
      } else {
        if (isLoading) return false
        return (this.hasCommonResults || this.hasQuestions || this.hasLlmResult)
      }
    },
    currentSafeList() {
      if (!this.AIresult) return []
      const resultMap = {
        '1': this.AIresult.articleResult,
        '2': this.AIresult.courseResult,
        '3': this.AIresult.caseResult
      }
      const arr = resultMap[this.curTabType] || []
      return Array.isArray(arr) ? arr : []
    },
    curShowList() {
      const safeArr = this.currentSafeList
      const countMap = {
        '1': this.showMoreCount.article,
        '2': this.showMoreCount.course,
        '3': this.showMoreCount.case
      }
      let end = countMap[this.curTabType]
      end = Number.isInteger(end) ? Math.max(0, end) : 0
      const endIndex = 5 + end * 3
      return safeArr.slice(0, endIndex)
    },
    isAllDataShown() {
      const safeArr = this.currentSafeList
      return this.curShowList.length >= safeArr.length
    }
  },
  components: {
    ListItem,
    AIloading,
    OverTimeTip,
    IntelligentRes,
  },
  beforeDestroy() {
    this.stopRequest()
    this.isOverTime = false
    this.aiLoading = false
  },
  methods: {
    stopRequest() {
      if (this.settime) clearInterval(this.settime) // 清除定时器
      this.controller1 && this.controller1.abort()
      this.controller2 && this.controller2.abort()
      this.controller3 && this.controller3.abort()
      this.controller4 && this.controller4.abort()
      this.summaryLoading = false
      this.questionsLoading = false
    },
    resetData() {
      this.AIresult = {
        questions: [],
        llm_result: '',
        caseResult: [],
        articleResult: [],
        courseResult: [],
      }
      this.summaryLoading = false
      this.questionsLoading = false
    },
    showMoreList() {
      if (this.curTabType === '1') {
        this.showMoreCount.article++
      }
      if (this.curTabType === '2') {
        this.showMoreCount.course++
      }
      if (this.curTabType === '3') {
        this.showMoreCount.case++
      }
      this.setAIresult((aiResult) => {
        aiResult.showMoreCount = this.showMoreCount
      })
    },
    // 获取智能搜索列表
    async handleGetAIList() {
      // 如果智能助手停用的话, 就停止搜索
      if (this.assistantIsStop) return
      let searchParams = sessionStorage.getItem('searchParams')
      if (this.aiLoading || this.summaryLoading || this.questionsLoading) return
      this.aiLoading = true
      this.isOverTime = false
      this.showMoreCount = {
        course: 0,
        article: 0,
        case: 0
      }
      if (searchParams) {
        let jsonSearchParams = JSON.parse(searchParams)
        if (sessionStorage.getItem('aiResult') && jsonSearchParams.searchContent === this.searchValue) {
          this.AIresult = JSON.parse(sessionStorage.getItem('aiResult'))
          this.messageContent = this.AIresult.llm_result || ''
          this.showMoreCount = this.AIresult.showMoreCount || {
            course: 0,
            article: 0,
            case: 0
          }
          this.aiLoading = false
          if (sessionStorage.getItem('isOverTime')) {
            this.isOverTime = JSON.parse(sessionStorage.getItem('isOverTime'))
          } else {
            this.isOverTime = false
          }
          this.summaryLoading = false
          this.questionsLoading = false
          return
        } else {
          sessionStorage.removeItem('aiResult')
          sessionStorage.removeItem('isOverTime')
          this.resetData()
        }
      } else {
        this.resetData()
        sessionStorage.removeItem('aiResult')
        sessionStorage.removeItem('isOverTime')
      }
      this.timeCount = 1
      this.stopRequest()
      this.handleSetTime()
      // 异步Web调用（知识库召回2.0）
      this.handleGetParams2()
      // 异步Web调用（知识库召回1.0）
      if (this.userInfo.memberType === 1) {
        this.handleGetParams1()
      }
      sessionStorage.setItem('searchParams', JSON.stringify({
        searchContent: this.searchValue,
        curTabType: this.curTabType,
        curTabKey: this.curTabKey
      }))
    },
    handleSetTime() {
      // 使用 setInterval 替代递归调用，简化逻辑
      this.settime = setInterval(() => {
        if (this.timeCount > this.overTimeCount) {
          this.isOverTime = true
          sessionStorage.setItem('isOverTime', this.isOverTime)
          this.aiLoading = false
          this.stopRequest()
        } else {
          this.timeCount++ // 递增计时器
        }
      }, 1000)
    },
    async handleGetParams2() { // Web调用（知识库召回2.0）
      if (this.searchValue === sessionStorage.getItem('paramsQueryTxt') && sessionStorage.getItem('aiResult')) return
      try {
        this.listStartTime = new Date().getTime()
        const url = `${process.env.baseURL}/bwhcpsa/v1/workflows/run`
        const body = {
          inputs: {
            query: this.searchValue,
            role: this.userInfo.memberType === 1 ? 'empolyee' : 'hcp',
          },
          response_mode: 'blocking',
          user: this.userInfo.memberType === 1
            ? `${this.userInfo.email},${this.userInfo.realName}`
            : `${this.userInfo.iepOpenId},${this.userInfo.realName}`,
        }
        // 创建 AbortController 实例
        this.controller1 = new AbortController()
        const signal = this.controller1.signal
        const result = await apiClient.post(url, body, {
          abortSignal: signal,
          headers: {
            Authorization: process.env.genaiToken.token5,
          },
        })
        this.AIParams = Object.assign({}, this.AIParams, result.data.outputs)
        sessionStorage.setItem('paramsQueryTxt', result.data.outputs.query)
        this.AIParams.role = `${this.userInfo.memberType}` === '1' ? 'empolyee' : 'hcp'
        // 如果是医生的话, 就只需要调用这一个接口 然后就记录时长, 中止定时超时
        if (this.userInfo.memberType === 0) {
          clearInterval(this.settime)
        }
        this.handleTrace({
          type: '2',
          startTime: this.listStartTime,
          tip: '请求成功',
        })
        this.handleGetResult()
      } catch (error) {
        if (error.name === 'AbortError') {
          if (this.isOverTime) {
            this.handleTrace({
              type: '2',
              startTime: this.listStartTime,
              tip: '请求超时',
            })
          }
        } else {
          this.handleTrace({
            type: '2',
            startTime: this.listStartTime,
            tip: '请求失败',
          })
        }
      }
    },
    async handleTrace({type, startTime, tip}) {
      const resultId = await this.handleTraceSearch(type, tip)
      await this.handleUpdateSearchDuration(resultId, startTime)
    },
    async handleUpdateSearchDuration(resultId, startTime) {
      let params = {
        id: resultId,
        duration: ((new Date().getTime() - startTime) / 1000).toFixed(2)
      }
      await updateSearchDuration(params)
    },
    async handleRefersh(type) {
      if (this.settime) clearInterval(this.settime)
      this.timeCount = 1
      this.handleSetTime()
      if (type === 3) {
        this.summaryLoading = true
      } else if (type === 4) {
        this.questionsLoading = true
      }
      this.handleGetParams1(type)
    },
    async handleGetParams1(source) { // Web调用（知识库召回1.0）
      try {
        const url = `${process.env.baseURL}/bwhcpsa/v1/workflows/run`
        const body = {
          inputs: {
            query: this.searchValue,
            role: this.userInfo.memberType === 1 ? 'empolyee' : 'hcp',
          },
          response_mode: 'blocking',
          user: this.userInfo.memberType === 1
            ? `${this.userInfo.email},${this.userInfo.realName}`
            : `${this.userInfo.iepOpenId},${this.userInfo.realName}`,
        }
        // 创建 AbortController 实例
        this.controller2 = new AbortController()
        const signal = this.controller2.signal
        const result = await apiClient.post(url, body, {
          abortSignal: signal,
          headers: {
            Authorization: process.env.genaiToken.token3,
          },
        })
        this.AIParams = Object.assign({}, this.AIParams, result.data.outputs)
        sessionStorage.setItem('paramsQueryTxt', result.data.outputs.query)
        this.AIParams.role = `${this.userInfo.memberType}` === '1' ? 'empolyee' : 'hcp'
        if (source) {
          if (source === 3) {
            // LLM 生成 summary
            this.handleGetFun(source)
          }
          if (source === 4) {
            // 猜你想问
            this.handleGetQuestions(source)
          }
        } else {
          // LLM 生成 summary
          this.handleGetFun()
          // 猜你想问
          this.handleGetQuestions()
        }
      } catch (error) {
      }
    },
    // LLM 生成 summary
    async handleGetFun(source) {
      this.messageContent = ''
      const THIS = this
      this.summaryLoading = true
      this.summaryStartTime = new Date().getTime()
      this.setAIresult((aiResult) => {
        aiResult.llm_result = ''
      })
      try {
        const url = `${process.env.baseURL}/bwhcpsa/v1/workflows/run`
        const {docs, query, role} = this.AIParams
        const inputs = Object.assign({}, {docs, query, role})
        const body = {
          inputs: inputs,
          response_mode: 'streaming',
          user: this.userInfo.memberType === 1
            ? `${this.userInfo.email},${this.userInfo.realName}`
            : `${this.userInfo.iepOpenId},${this.userInfo.realName}`,
        }
        this.controller3 = new AbortController()
        const signal = this.controller3.signal
        fetchEventSource(`${url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: process.env.genaiToken.token4,
          },
          body: JSON.stringify(body),
          signal: signal,
          async onopen(response) {
            if (response.status !== 200) {
              await THIS.handleTrace({
                type: '3',
                startTime: THIS.summaryStartTime,
                tip: '请求失败',
              })
            }
          },
          async onmessage(msg) {
            const jsonText = JSON.parse(msg.data)
            if (jsonText.event === 'text_chunk') {
              THIS.messageContent += jsonText.data.text
              THIS.setAIresult((aiResult) => {
                aiResult.llm_result = THIS.messageContent
              })
            }
            if (jsonText.event === 'workflow_finished') {
              THIS.summaryLoading = false
              if (source) clearInterval(THIS.settime)
              THIS.aiLoading = false
              if (!THIS.aiLoading && !THIS.summaryLoading && !THIS.questionsLoading) {
                if (THIS.settime) clearInterval(THIS.settime)
              }
              await THIS.handleTrace({
                type: '3',
                startTime: THIS.summaryStartTime,
                tip: '请求成功',
              })
              THIS.controller3.abort()
            }
            if (THIS.messageContent.length > 0) {
              THIS.summaryLoading = false
              THIS.aiLoading = false
              if (source) clearInterval(THIS.settime)
            }
          },
          onclose() {
            THIS.summaryLoading = false
            THIS.aiLoading = false
          },
          onerror() {
            THIS.summaryLoading = false
            THIS.aiLoading = false
            throw new Error('阻止自动重连')
          },
        })
        signal.addEventListener('abort', async () => {
          if (THIS.isOverTime) {
            await THIS.handleTrace({
              type: '3',
              startTime: THIS.summaryStartTime,
              tip: '请求超时',
            })
          }
        })
      } catch (e) {
        THIS.summaryLoading = false
        THIS.controller3.abort()
      }
    },
    // 猜你想问
    async handleGetQuestions(source) {
      this.questionsLoading = true
      this.setAIresult((aiResult) => {
        aiResult.questions = []
      })
      try {
        this.questionsStartTime = new Date().getTime()
        const url = `${process.env.baseURL}/bwhcpsa/v1/workflows/run`
        const {docs, query, role} = this.AIParams
        const inputs = Object.assign({}, {docs, query, role})
        const body = {
          inputs: inputs,
          response_mode: 'blocking',
          user: this.userInfo.memberType === 1 ? `${this.userInfo.email},${this.userInfo.realName}` : `${this.userInfo.iepOpenId},${this.userInfo.realName}`
        }
        // 创建 AbortController 实例
        this.controller4 = new AbortController()
        const signal = this.controller4.signal
        const result = await apiClient.post(url, body, {
          abortSignal: signal,
          headers: {
            Authorization: process.env.genaiToken.token1,
          },
        })
        if (!result.data.outputs || result.data.status === 'failed') {
          throw new Error('failed')
        }
        this.setAIresult((aiResult) => {
          aiResult.questions = result.data.outputs.questions
        })
        this.questionsLoading = false
        this.aiLoading = false
        if (!this.aiLoading && !this.summaryLoading && !this.questionsLoading) {
          if (this.settime) clearInterval(this.settime)
        }
        await this.handleTrace({
          type: '4',
          startTime: this.questionsStartTime,
          tip: '请求成功'
        })
      } catch (error) {
        this.setAIresult((aiResult) => {
          aiResult.questions = []
        })
        this.aiLoading = false
        this.questionsLoading = false
        if (error.name === 'AbortError') {
          if (this.isOverTime) {
            await this.handleTrace({
              type: '4',
              startTime: this.questionsStartTime,
              tip: '请求超时',
            })
          }
        } else {
          await this.handleTrace({
            type: '4',
            startTime: this.questionsStartTime,
            tip: '请求失败',
          })
        }
      } finally {
        if (source) {
          clearInterval(this.settime)
        }
      }
    },
    setAIresult(callback) {
      const aiResultStr = sessionStorage.getItem('aiResult')
      let aiResult = null

      try {
        if (aiResultStr) {
          aiResult = JSON.parse(aiResultStr)
        } else {
          aiResult = {...this.AIresult} // 避免引用共享
        }
        callback(aiResult)
        sessionStorage.setItem('aiResult', JSON.stringify(aiResult))
        this.AIresult = aiResult
      } catch (error) {
        console.error('解析或写入 aiResult 出错:', error)
      }
    },
    // 知识库召回过滤
    async handleGetResult() {
      // 病例
      const casesharingDocs = JSON.parse(this.AIParams.casesharing_docs)
      // 文献
      const iepDocs = JSON.parse(this.AIParams.iep_docs)
      // 课程/知识点
      const knowledgeDocs = JSON.parse(this.AIParams.knowledge_docs)
      try {
        const newCasesharingDocs = this.filterDocsFun(casesharingDocs, 'case', 3)
        const newIepDocs = this.filterDocsFun(iepDocs, 'article', 1)
        const newKnowledgeDocs = this.filterDocsFun(knowledgeDocs, 'course', 2)

        // 病例
        if (newCasesharingDocs.function) {
          let {data: filterDocs} = await newCasesharingDocs.function

          let sortScoreMap = new Map()
          casesharingDocs.forEach(doc => {
            const key = `${doc.metadata.doc_metadata._lakehouse_id}`
            let score = doc.metadata.score
            if (!sortScoreMap.has(key)) sortScoreMap.set(key, score)
          })
          filterDocs = filterDocs.map(item => {
            const key = `${item.lakehouseId}`
            item.score = sortScoreMap.get(key)
            return item
          })
          filterDocs = filterDocs.sort((a, b) => b.score - a.score)

          this.setAIresult((aiResult) => {
            aiResult['caseResult'] = filterDocs
          })
        }
        // 文章
        if (newIepDocs.function) {
          let {data: filterDocs} = await newIepDocs.function

          let sortScoreMap = new Map()
          iepDocs.forEach(doc => {
            const key = `${doc.metadata.doc_metadata._lakehouse_id}`
            let score = doc.metadata.score
            if (!sortScoreMap.has(key)) sortScoreMap.set(key, score)
          })
          filterDocs = filterDocs.map(item => {
            const key = `${item.lakehouseId}`
            item.score = sortScoreMap.get(key)
            return item
          })
          filterDocs = filterDocs.sort((a, b) => b.score - a.score)

          this.setAIresult((aiResult) => {
            aiResult['articleResult'] = filterDocs
          })
        }
        // 课程
        /**
         * 处理知识文档数据，整合AI返回结果与本地接口数据
         *
         * 此函数主要完成以下任务：
         * 1. 从 newKnowledgeDocs.function 获取自定义接口的课程数据 filterDocs；
         * 2. 遍历 knowledgeDocs（AI 接口原始数据）构建两个映射结构：
         *    - sortScoreMap：记录每个课程小节的得分；
         *    - knowledgeMap：记录具体知识点的映射关系；
         * 3. 对 filterDocs 进行过滤和映射处理：
         *    - 只保留那些在 knowledgeDocs 中存在的课程小节；
         *    - 设置每个课程项的 score 字段；
         *    - 标记 knowledgeList 中命中的知识点（isHit = true）；
         *    - 截取命中项为中心的三个知识点列表；
         * 4. 最终将处理后的结果按分数排序，并更新到 AI 结果中。
         *
         * @param {Object} newKnowledgeDocs - 包含 function 属性的对象，function 是一个异步函数，用于获取自定义接口数据
         * @param {Array} knowledgeDocs - AI 接口返回的知识文档原始数据列表
         * @returns {Promise<void>} - 无返回值，通过 this.setAIresult 更新状态
         */
        if (newKnowledgeDocs.function) {
          let {data: filterDocs} = await newKnowledgeDocs.function
          let sortScoreMap = new Map()
          let knowledgeMap = new Map()
          let cacheExistId = []

          // 构建缓存ID、得分映射和知识点映射
          knowledgeDocs.forEach(doc => {
            if (doc && doc.metadata && doc.metadata.doc_metadata) {
              const {
                _original_id: originalId,
                _section_id: sectionId,
                _material_knowledge_id: materialKnowledgeId
              } = doc.metadata.doc_metadata
              const {score} = doc.metadata
              if (originalId && sectionId) {
                const key = `${originalId}-${sectionId}`
                if (!cacheExistId.includes(key)) cacheExistId.push(key)
                if (!sortScoreMap.has(key)) sortScoreMap.set(key, score)
                if (materialKnowledgeId) {
                  const key = `${originalId}-${sectionId}-${materialKnowledgeId}`
                  knowledgeMap.set(key, doc)
                } else {
                  knowledgeMap.set(key, doc)
                }
              }
            }
          })

          /**
           * 数据整合逻辑说明：
           * - 调用自己的接口获取到的列表数据 filterDocs
           * - knowledgeDocs 为 AI 接口返回的原始数据
           * - map filterDocs 数组，从 knowledgeDocs 中 find 出匹配项（课程 id 和小节 id 匹配）
           * - 如果有匹配项的话，从匹配项中取出 _material_knowledge_id
           * - 遍历 knowledgeList，如果 _material_knowledge_id 等于 item.knowledgeList[knowIndex].id，
           *   则设置 knowledgeList[knowIndex].isHit = true
           * - 如果没有匹配项，说明调用自己接口获取的数据在 knowledgeDocs 中不存在，
           *   此时只显示匹配的项目
           */
          filterDocs = filterDocs.filter(item => {
            const key = `${item.baseId}-${item.sectionId}`
            return cacheExistId.includes(key)
          }).map(item => {
            const scoreKey = `${item.baseId}-${item.sectionId}`
            item.score = sortScoreMap.get(scoreKey)
            return item
          }).sort((a, b) => b.score - a.score).map(item => {
            // 安全访问检查
            if (!item) return item

            if (item.knowledgeList && item.knowledgeList.length > 0) {
              // 用于记录命中的知识点中分数最高的那个的ID
              let bestHitId = null
              let bestHitScore = -Infinity

              // 一次性处理所有知识点：设置分数并找出最佳命中项
              item.knowledgeList = item.knowledgeList.map(know => {
                const key = `${item.baseId}-${item.sectionId}-${know.id}`
                const doc = knowledgeMap.get(key)

                if (doc) {
                  // 设置分数
                  know.score = doc.metadata.score

                  // 更新最佳命中项（只保留分数最高的那个）
                  if (know.score > bestHitScore) {
                    bestHitScore = know.score
                    bestHitId = know.id
                  }
                }

                return know
              })

              // 只为分数最高的命中标记 isHit = true
              if (bestHitId !== null) {
                item.knowledgeList.forEach(know => {
                  know.isHit = (know.id === bestHitId)
                })
              }

              // 截取知识点列表
              this.$set(item, 'knowledgeList', this.getTrimmedKnowledgeList(item.knowledgeList))
            }

            return item
          })
          this.setAIresult((aiResult) => {
            aiResult['courseResult'] = filterDocs
          })
        }

        this.aiLoading = false
      } catch (error) {
        this.setAIresult((aiResult) => {
          aiResult['courseResult'] = []
          aiResult['articleResult'] = []
          aiResult['caseResult'] = []
        })
        this.aiLoading = false
      }
    },
    getTrimmedKnowledgeList(knowledgeList) {
      // 边界情况：数组为空或长度小于等于3
      if (!knowledgeList || knowledgeList.length <= 3) {
        return knowledgeList || []
      }

      const hitIndex = knowledgeList.findIndex(know => know.isHit === true)

      // 没有找到命中项，返回前3个元素
      if (hitIndex === -1) {
        return knowledgeList.slice(0, 3)
      }

      // 找到命中项，尝试返回包含该元素的3个元素
      let start, end

      // 尽可能返回3个元素，优先保持命中项在中间位置
      if (hitIndex === 0) {
        // 命中第一项，返回前三项
        start = 0
        end = 3
      } else if (hitIndex === knowledgeList.length - 1) {
        // 命中最后一项，返回后三项
        start = knowledgeList.length - 3
        end = knowledgeList.length
      } else {
        // 命中中间项，返回前一个、命中项和后一个
        start = hitIndex - 1
        end = hitIndex + 2
      }

      return knowledgeList.slice(start, end)
    },
    // 相关性过滤后的知识库召回docs 去重处理
    filterDocsFun(docs, type, queryType) {
      const filterDocs = docs
      let removeDuplicateDocs, ids
      if (type === 'case' || type === 'article') {
        removeDuplicateDocs = this.removeDuplicatesBy(filterDocs, doc => doc.title)
      } else {
        removeDuplicateDocs = this.removeDuplicatesBy(filterDocs, item => item.metadata.doc_metadata._original_id)
      }
      if (type === 'case' || type === 'article') {
        ids = removeDuplicateDocs.map(res => res.metadata.doc_metadata._lakehouse_id)
      } else {
        ids = removeDuplicateDocs.map(item => item.metadata.doc_metadata._original_id)
      }
      if (ids.length <= 0) {
        return {removeDuplicateDocs}
      } else {
        return {
          removeDuplicateDocs,
          function: getListBylakehouseId({lakehouseIds: ids, queryType: queryType})
        }
      }
    },
    // 通用去重函数
    removeDuplicatesBy(array, keyFn) {
      const seen = new Set()
      const result = []
      for (const item of array) {
        const key = keyFn(item)
        if (!seen.has(key)) {
          seen.add(key)
          result.push(item)
        }
      }
      return result
    },
    async handleTraceSearch(type, tip) {
      const res = await handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': `${tip}-${this.searchValue}`,
        'sessionId': localStorage.getItem('sessionId'),
        'type': type, // '1: ‘搜索‘， 2: ’智能',
        'entrance': 52
      })
      return res.data
    },
    // 长按显示框框
    handleLongPress(item, index) {
      this.curShowList.forEach(item => {
        this.$set(item, 'isShowFeedback', false)
      })
      this.$set(item, 'isShowFeedback', true)
      this.feedBackIndex = index
    },
    // 关闭反馈弹窗
    handleClose() {
      this.curShowList.forEach(item => {
        this.$set(item, 'isShowFeedback', false)
      })
    },
    // 反馈操作
    handleFeedBack(type) {
      this.curShowList.forEach(item => {
        this.$set(item, 'isShowFeedback', false)
      })
      // type、反馈类型1系统反馈意见2推荐反馈意见3每日答题反馈意见
      // baseId 业务id，
      // baseType 业务类型 1文献2课程3病例
      // baseTitle 业务标题（文献、课程、病例标题）
      let content = ''
      if (type === 'feedback') {
        content = this.feedModel
      } else {
        content = type ? '是' : '否'
      }
      let params = {
        type: 5,
        baseId: this.curShowList[this.feedBackIndex].baseId,
        baseType: this.curShowList[this.feedBackIndex].type,
        baseTitle: this.curShowList[this.feedBackIndex].title,
        title: '只能搜索反馈',
        content,
        state: 2,
        userName: this.userInfo.realName,
        userId: this.userInfo.id,
        role: this.userInfo.roles[0],
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        openId: this.userInfo.iepOpenId
      }
      sendFeedback(params).then(res => {
        if (res.code === 0) {
          this.feedModel = ''
          this.isFeedBack = false
          this.$toast('反馈成功，将为您优化推荐结果')
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
.cons-list {
  padding: 0 16px;
  box-sizing: border-box;
}

.view-more-box {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 10px;

  span {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #EB1700;
  }

  img {
    height: 8px;
    margin-left: 5px;
  }
}

.ai-block {
  padding: 0 14px 20px;
  box-sizing: border-box;
  margin-top: 10px;

  .cons-list {
    padding: 0;
  }

  .ai-block-cons {
    background: #F9F8F7;
    border-radius: 12px;
    padding: 12px 10px 1px 14px;
    box-sizing: border-box;

    & + .ai-block-cons {
      margin-top: 10px;
    }

    .tip-img2 {
      width: 104px;
      display: block;
      margin-bottom: 8px;
    }
  }
}

.ai-question {
  .top {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .tag {
    font-size: 14px;
    width: 100%;
    line-height: 24px;
    box-sizing: border-box;
    border-radius: 4px;
    background: #fff;
    margin-top: 10px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #000000;
    padding: 6px 12px;
    box-sizing: border-box;
  }

  .ai-cons-html {
    margin-bottom: 20px;
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 14px;
    color: #333;
    line-height: 24px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    transition: max-height 0.5s ease;
    /* 添加过渡效果 */

    &.close {
      // -webkit-line-clamp: unset;
      /* 展开后不限制行数 */
      max-height: null;
    }

    &.open {
      // -webkit-line-clamp: 7;
      /* 展开后不限制行数 */
      max-height: 168px;
    }
  }
}

.tip-img3 {
  width: 70px;
  display: block;
}

.refresh {
  width: 20px;
  margin-left: 10px;
  cursor: pointer;
}

.show-feedback {
  position: relative;

  .wrapp-con {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;

    .wrapp-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, .5);
      z-index: 99;
    }

    .wrapps {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      z-index: 999;

      .img-close {
        width: 18px;
        right: 13px;
        box-sizing: border-box;
        display: block;
        position: absolute;
        top: 8px;
      }

      .top-txt {
        font-size: 13px;
        color: #FFFFFF;
        line-height: 20px;
        margin-bottom: 8px;
        padding-left: 13px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .top-btn {
        display: flex;
        align-items: center;
        padding: 0 13px;
        box-sizing: border-box;

        .btn-left {
          width: 110px;
          margin-right: 16px;
          border-radius: 4px;
          background: rgba(255, 255, 255, 0.45);
          display: flex;
          align-items: center;
          justify-content: center;

          .img-icon {
            width: 16px;
            height: 16px;
            display: block;
            margin-right: 4px;
          }

          .btn-txt {
            font-size: 14px;
            color: #FFFFFF;
          }
        }

        .btn-txt2 {
          font-size: 13px;
          flex: 1;
          text-align: right;
          color: #FFFFFF;
        }
      }
    }
  }
}

/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    box-sizing: border-box;

    .img-wrap {
      width: 80px;
      display: block;
      margin-bottom: 18px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .wrap-txt {
      font-size: 17px;
      line-height: 24px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 15px;
      text-align: center;

      &.wrap-txt2 {
        border-bottom: 1px solid #A9AEB6;
        padding-bottom: 10px;
        box-sizing: border-box;
        text-align: left;
        margin-bottom: 14px;
      }
    }

    .wrap-con {
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 30px;
      background: rgba(0, 0, 0, 0.02);
      font-size: 14px;
      color: #333;

      .van-cell {
        background: rgba(0, 0, 0, 0.02);
      }
    }

    .wrap-txt3 {
      position: relative;

      &::before {
        content: '*';
        font-size: 17px;
        color: #FF0000;
        width: 9px;
        text-align: center;
        display: inline-block;
      }
    }

    .wrap-con {
      width: 288px;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 16px;
      margin-bottom: 20px;

      .href-txt {
        color: #EB1700;
      }
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      height: 55px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/AiList.vue